require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/fn/object/entries.js
// module id = 329
// module chunks = 0